import { render, staticRenderFns } from "./Cms1500.vue?vue&type=template&id=bddb56d6"
import script from "./Cms1500.vue?vue&type=script&lang=js"
export * from "./Cms1500.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports